import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import MobileNav from './components/MobileNav';
import SideBar from './components/SideBar';
import { getUserReportList, getUserReportDelete } from '../../redux/actions/AuthActions';
import { connect } from 'react-redux';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import TableFilter from './components/TableFilter';
import { CSVLink } from 'react-csv';
import { FiDownload, FiEye, FiTrash2 } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';



const UserReportScreen = ({ userReportList, getUserReportList, getUserReportDelete, userReportDelete }) => {

    const navigate = useNavigate()

    const { loading, reports, error } = userReportList;
    const { loading:userReportLoading, success, error:userReportErr } = userReportDelete;

    const [filterData, setFilterData] = useState([]);


    useEffect(() => {
        getUserReportList()
    }, [getUserReportList, success])


    const [rowLimit, setRowLimit] = useState(5)
    const [currentPage, setCurrentPage] = useState(1);

    const rowHandler = (e) => {
        const { value } = e.target;
        setRowLimit(value)
    }

    const indexOfLastData = currentPage * rowLimit;
    const indexOfFirstData = indexOfLastData - rowLimit;
    const reportData = reports?.slice(indexOfFirstData, indexOfLastData)
    const filterUserData = filterData?.slice(indexOfFirstData, indexOfLastData)


    const searchHandler = (e) => {
        if (e.target.value !== '') {
            const filter = reports.filter(item => {
                return Object.values(item).join('').toLowerCase().includes(e.target.value.toLowerCase())
            })
            setFilterData(filter)
        } else {
            setFilterData(reports)
        }
    }


    const userDeleteHandler = (id) => {
        if (window.confirm(`Are you sure, you want delete ${id}!`)) {
            getUserReportDelete(id);
        }
    }

    const viewReportDetails = (id) => {
        navigate(`/admin/report/${id}`)
    }


    const headers = [
        { label: "ID", key: "_id" },
        { label: "Name", key: "name" },
        { label: "Email", key: "email" },
        { label: "Message", key: "message" },
        { label: "CreatedAt", key: "createdAt" },
        { label: "UpdatedAt", key: "updatedAt" },
    ];


    return (
        <div className='relative bg-gray-50 min-h-screen'>
            <SideBar />
            <MobileNav />
            <Header />
            <div className='md:ml-72 px-4 md:px-2'>
                <div className='my-6 text-3xl font-bold tracking-wide uppercase md:text-center'>
                    reports
                </div>
                <div className='flex justify-between items-center flex-col md:flex-row'>
                    <div className='flex items-center shadow py-2 px-4 sen-font rounded bg-red-300 md:mr-10 mb-5 md:mb-0 w-full md:w-fit'>
                        <FiDownload />
                        <CSVLink headers={headers} data={reports} filename="reports.csv" className='ml-3'>Export CSV</CSVLink>
                    </div>

                    <input
                        name='search'
                        type='search'
                        onChange={searchHandler}
                        placeholder='search...'
                        className="shadow-sm bg-gray-50 md:w-60 border border-gray-300 text-gray-900 text-sm rounded-lg outline-[#edf2f4] focus:ring-[#83c5be] focus:border-[#83c5be] w-full p-2.5"
                    />
                </div>

                { userReportLoading && <Loader /> }
                { userReportErr && <Message error msg={userReportErr} /> }

                { loading ? <Loader /> : error ? <Message error msg={error} /> : (
                    <>

                        <div className="relative overflow-x-auto my-10">
                            <table className="w-full text-sm text-left text-black ">
                                <thead className="text-xs text-black mont-font text-white uppercase bg-[#0b2545]">
                                    <tr className='border border-gray-300'>
                                        <th className="px-6 py-3 border border-gray-300">ID</th>
                                        <th className="px-6 py-3 border border-gray-300">NAME</th>
                                        <th className="px-6 py-3 border border-gray-300">EMAIL</th>
                                        <th className="px-6 py-3 border border-gray-300">CREATED AT</th>
                                        <th className="px-6 py-3 border border-gray-300">
                                            <span className="sr-only">ACTION</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        filterData.length ? (
                                            <>
                                                {
                                                    filterUserData.map((val) => (
                                                        <tr className="bg-white border border-gray-300 transition duration-300 ease-in-out hover:bg-gray-200 sen-font" key={val._id}>
                                                            <td className="p-4 border border-gray-300">{val._id}</td>
                                                            <td className="p-4 border border-gray-300">{val.name}</td>
                                                            <td className="p-4 border border-gray-300 cursor-pointer">
                                                                <a href={`mailto:${val.email}`} className='hover:underline'>{val.email}</a>
                                                            </td>
                                                            <td className="p-4 border border-gray-300">{val.createdAt.substring(0, 10)}</td>
                                                            <td className='p-4 border border-gray-300'>
                                                                <button className='px-3 py-1' onClick={() => viewReportDetails(val._id)}>
                                                                    <FiEye className='text-blue-800 text-base' />
                                                                </button>
                                                                <button className='px-3 py-1' onClick={() => userDeleteHandler(val._id)} >
                                                                    <FiTrash2 className='text-red-700 text-base' />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </>
                                        ) : (
                                            <>
                                                {
                                                    reportData.map((val) => (
                                                        <tr className="bg-white border border-gray-300 transition duration-300 ease-in-out hover:bg-gray-200 sen-font" key={val._id}>
                                                            <td className="p-4 border border-gray-300">{val._id}</td>
                                                            <td className="p-4 border border-gray-300">{val.name}</td>
                                                            <td className="p-4 border border-gray-300 cursor-pointer">
                                                                <a href={`mailto:${val.email}`} className='hover:underline'>{val.email}</a>
                                                            </td>
                                                            <td className="p-4 border border-gray-300">{val.createdAt.substring(0, 10)}</td>
                                                            <td className='p-4 border border-gray-300'>
                                                                <button className='px-3 py-1' onClick={() => viewReportDetails(val._id)}>
                                                                    <FiEye className='text-blue-800 text-base' />
                                                                </button>
                                                                <button className='px-3 py-1' onClick={() => userDeleteHandler(val._id)}>
                                                                    <FiTrash2 className='text-red-700 text-base' />
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        <TableFilter rowHandler={rowHandler} rowLimit={rowLimit} data={reports} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                    </>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    userReportList: state.userReportList,
    userReportDelete: state.userReportDelete
})

export default connect(mapStateToProps, { getUserReportList, getUserReportDelete })(UserReportScreen);